/* tslint:disable */
/* eslint-disable */
/**
 * Animare Management API
 * This API provides methods for viewing and modifying animare database data for authorities. 
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RegistrationDto } from './RegistrationDto';
import {
    RegistrationDtoFromJSON,
    RegistrationDtoFromJSONTyped,
    RegistrationDtoToJSON,
} from './RegistrationDto';

/**
 * 
 * @export
 * @interface PageResultOfRegistrationDto
 */
export interface PageResultOfRegistrationDto {
    /**
     * 
     * @type {Array<RegistrationDto>}
     * @memberof PageResultOfRegistrationDto
     */
    items?: Array<RegistrationDto>;
    /**
     * 
     * @type {number}
     * @memberof PageResultOfRegistrationDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PageResultOfRegistrationDto
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof PageResultOfRegistrationDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageResultOfRegistrationDto
     */
    totalPages?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultOfRegistrationDto
     */
    hasNext?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultOfRegistrationDto
     */
    hasPrevious?: boolean;
}

/**
 * Check if a given object implements the PageResultOfRegistrationDto interface.
 */
export function instanceOfPageResultOfRegistrationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PageResultOfRegistrationDtoFromJSON(json: any): PageResultOfRegistrationDto {
    return PageResultOfRegistrationDtoFromJSONTyped(json, false);
}

export function PageResultOfRegistrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageResultOfRegistrationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(RegistrationDtoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
    };
}

export function PageResultOfRegistrationDtoToJSON(value?: PageResultOfRegistrationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(RegistrationDtoToJSON)),
        'page': value.page,
        'size': value.size,
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
        'hasNext': value.hasNext,
        'hasPrevious': value.hasPrevious,
    };
}

